import { currencyTag } from "../../utilities/formaters";
import { Currencies as CurrencyEnum } from "./enums";

export const accountBalanceDiffs = [
  {
    asOfDate: new Date("2018-05-16"),
    Type: "Untracked difference",
    ClientAccount: -21494.59,
    SavelendAccount: 0,
    BgDeposits: 0,
    BgInvoices: 0,
    TaxPaid: 0,
    TaxWithHeld: 0,
  },
];

export const currencyList = [
  { name: currencyTag[CurrencyEnum.Sek], value: CurrencyEnum.Sek },
  { name: currencyTag[CurrencyEnum.Eur], value: CurrencyEnum.Eur },
];
